import { Button, Dialog, Flex, IconButton } from '@radix-ui/themes';
import { XIcon } from '@phosphor-icons/react';
import IconSessionExpiring from '../icons/icon-session-expiring.svg?react';
import { IDLE_WARNING_MS } from '../../../hooks/useIdleTimeout';
import styles from './index.module.css';

const WARNING_MINUTES = IDLE_WARNING_MS / 60 / 1000;
const LOGOUT_GRACE_SECONDS = 60;

type IdleTimeoutModalProps = {
  onContinue: () => void;
  onLogOut: () => void;
};

function IdleTimeoutModal({ onContinue, onLogOut }: IdleTimeoutModalProps) {
  return (
    <Dialog.Root
      open
      onOpenChange={(open) => {
        if (!open) {
          onContinue();
        }
      }}
    >
      <Dialog.Content className={styles.content} maxWidth="520px">
        <IconButton
          variant="ghost"
          className={styles.closeButton}
          onClick={onContinue}
          aria-label="Continue session"
        >
          <XIcon />
        </IconButton>

        <Flex direction="column" align="center" gap="6" mb="6">
          <IconSessionExpiring className={styles.icon} />

          <Dialog.Title className={styles.title} mb="0" weight="medium">
            Your session is about to expire
          </Dialog.Title>

          <Dialog.Description className={styles.description}>
            {`You've been inactive for ${WARNING_MINUTES} minutes. You will be logged out in ${LOGOUT_GRACE_SECONDS} seconds.`}
          </Dialog.Description>
        </Flex>

        <Flex direction="column" gap="6" width="100%">
          <Button size="3" className={styles.primaryButton} onClick={onContinue}>
            Continue session
          </Button>

          <Button size="3" variant="outline" color="gray" className={styles.secondaryButton} onClick={onLogOut}>
            Log out now
          </Button>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
}

export default IdleTimeoutModal;
